import { FaFloppyDisk, FaHouse, FaPen, FaXmark } from 'react-icons/fa6';

/** Share the same permitted actions between a table row and a mobile place card. */
const SavedPlaceActions = ({
  place,
  canEditPlaces,
  canChangeHomePlace,
  isEditing,
  showLabels = false,
  onRenamePlace,
  onChangeHomePlace,
  onDeletePlace,
}) => {
  const placeName = place.title || 'this place';
  const actionClassName = showLabels
    ? 'btn btn-secondary btn-sm d-inline-flex align-items-center gap-2'
    : 'user-menu-icon-button';

  return (
    <div
      className={`saved-place-actions d-flex align-items-center ${
        showLabels ? 'flex-wrap gap-2' : 'justify-content-end gap-1'
      }`}
    >
      {canEditPlaces && (
        <button
          type="button"
          className={actionClassName}
          aria-label={isEditing ? `Save the title of ${placeName}` : `Rename ${placeName}`}
          title={isEditing ? 'Save title' : 'Rename'}
          onClick={onRenamePlace}
        >
          {isEditing ? <FaFloppyDisk aria-hidden="true" /> : <FaPen aria-hidden="true" />}
          {showLabels && (isEditing ? 'Save title' : 'Rename')}
        </button>
      )}
      {!place.DefaultLocationUserHome && canChangeHomePlace && (
        <button
          type="button"
          className={actionClassName}
          aria-label={`Make ${placeName} your home place`}
          title="Make home"
          onClick={(event) => {
            event.stopPropagation();
            onChangeHomePlace(place);
          }}
        >
          <FaHouse aria-hidden="true" />
          {showLabels && 'Make home'}
        </button>
      )}
      {!place.DefaultLocationUserHome && canEditPlaces && (
        <button
          type="button"
          className={actionClassName}
          data-tone="danger"
          aria-label={`Delete ${placeName}`}
          title="Delete"
          onClick={() => onDeletePlace(place)}
        >
          <FaXmark aria-hidden="true" />
          {showLabels && 'Delete'}
        </button>
      )}
    </div>
  );
};

export default SavedPlaceActions;
